import { render, staticRenderFns } from "./report-section.vue?vue&type=template&id=536fa613&scoped=true"
import script from "./report-section.vue?vue&type=script&lang=js"
export * from "./report-section.vue?vue&type=script&lang=js"
import style0 from "./report-section.vue?vue&type=style&index=0&id=536fa613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536fa613",
  null
  
)

export default component.exports